export default __webpack_public_path__ + "static/media/coinca l plano2.e17011b4.jpg";